import AppService from "src/services/appService";
import { setLocalStorageToken } from "src/utils/helpers";

export const LOGIN_REQUEST = "@account/login-request";
export const LOGIN_SUCCESS = "@account/login-success";
export const LOGIN_FAILURE = "@account/login-failure";
export const SILENT_LOGIN = "@account/silent-login";
export const LOGOUT = "@account/logout";
export const REGISTER = "@account/register";
export const UPDATE_PROFILE = "@account/update-profile";

export function login(login, password) {
  return async (dispatch) => {
    try {
      dispatch({ type: LOGIN_REQUEST });
      const appService = new AppService();
      const user = await appService.login(login, password);
      if (user) {
        setLocalStorageToken(user.token);
        localStorage.setItem("policies", JSON.stringify(user.policies_groups));
        dispatch({
          type: LOGIN_SUCCESS,
          payload: {
            user
          }
        });
      }
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE });
      throw error;
    }
  };
}

export function setUserData(user) {
  return (dispatch) =>
    dispatch({
      type: SILENT_LOGIN,
      payload: {
        user
      }
    });
}

export function logout() {
  return async (dispatch) => {
    const appService = new AppService();

    appService.logout();

    dispatch({
      type: LOGOUT
    });
  };
}

export function register() {
  return true;
}
